import { render, staticRenderFns } from "./LiteratureEdit.vue?vue&type=template&id=2bebe2d4&scoped=true&"
import script from "./LiteratureEdit.vue?vue&type=script&lang=js&"
export * from "./LiteratureEdit.vue?vue&type=script&lang=js&"
import style0 from "./LiteratureEdit.vue?vue&type=style&index=0&id=2bebe2d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bebe2d4",
  null
  
)

export default component.exports